var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({background:_vm.backgTheme=='dark'?'#1a1a1a':''}),attrs:{"id":"app"},on:{"touchstart":_vm.bodyTouchStart,"touchmove":_vm.bodyTouchMove,"touchend":_vm.bodyTouchEnd}},[_c('transition',{attrs:{"name":_vm.transitionName}},[(_vm.isRouterAlive)?_c('router-view',{key:new Date().getTime(),staticClass:"appView"}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41f88c3b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 